
define(
	'Anchorgroup.CheckoutCustomization.CheckoutCustomization'
,   [
		'OrderWizard.Module.PaymentMethod.Selector',
		'OrderWizard.Module.CartSummary',
		'OrderWizard.Module.Address',
		'Address.Details.View',
		'OrderWizard.Module.PaymentMethod.Creditcard',
		'underscore'
	]
,   function (
		OrderWizardModulePaymentMethodSelector,
		OrderWizardModuleCartSummary,
		OrderWizardModuleAddress,
		AddressDetailsView,
		OrderWizardModulePaymentMethodCreditcard,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
		
			/** @type {LayoutComponent} */

			var cart = container.getComponent('Cart');
			var checkout = container.getComponent('Checkout');
			var layout = container.getComponent('Layout');

			// Information about credit card fee
			var ccFeeApplied = false;
			var paymentMethod;
			var summaryHTML;

			OrderWizardModuleAddress.prototype.getSelectedAddress = function(e){
				console.log(this)
				if (!this.addressId)
				{
					if (this.sameAs && this.tempAddress)
					{
						return new AddressModel(this.tempAddress);
					}
		
					// if the user is guest it only has 1 address for this module so we return that address or a new one
					if (this.isGuest)
					{
						return this.getFixedAddress();
					}
				}
		
				return this.addresses.get(this.addressId) || this.getEmptyAddress();
			}
		
			var Address_Details_View = AddressDetailsView['__esModule'] ? AddressDetailsView.AddressDetailsView : AddressDetailsView;
			Address_Details_View.prototype.getContext = _.wrap(Address_Details_View.prototype.getContext, function(fn) {
				var context = fn.apply(this, _.toArray(arguments).slice(1));
				context.isValidAddress = true;
				if(this.model.id == -1){
					context.isValidAddress = false
				}
				return context;
			});
			
			OrderWizardModuleCartSummary.prototype.initialize = _.wrap(OrderWizardModuleCartSummary.prototype.initialize, function(fn) {
				fn.apply(this, _.toArray(arguments).slice(1));

				var Config = this.wizard.application.getConfig()
				,	minimumuCreditCardFee = parseFloat(Config.get('CreditCardFee.minCreditCardFee')) || 0
				,	creditCards = Config.get('CreditCardFee.creditCards');
				
				this.model.get('paymentmethods').on('add change', function(model){
					var paymentType = model.get('type')
					,	creditcard = model.get('creditcard')
					,	cardType = !_.isEmpty(creditcard) ? creditcard['paymentmethod']['name'] : '';
					
					if(paymentType == "creditcard" && !!cardType){
						var creditCardObj = _.find(creditCards, {name: cardType})
						,	creditCardFeeInPercentage = creditCardObj ? creditCardObj['fee'] : minimumuCreditCardFee
						,	creditCardFee = parseFloat(creditCardFeeInPercentage/100);
						
						this.creditCardFee = creditCardFee;
						this.creditCardFeeText = !isNaN(creditCardFee) ? creditCardFeeInPercentage + '% Card Fee' : '';
						this.render();
					}
				}, this);
			});
			
			// When summary module loads, calculate fee and new amount, and find out if fee should be applied
			OrderWizardModuleCartSummary.prototype.getContext = _.wrap(OrderWizardModuleCartSummary.prototype.getContext, function(fn) {
				var context = fn.apply(this, _.toArray(arguments).slice(1));

				var currentTotal = context.model.attributes.summary.total;
				var cardFee = currentTotal * this.creditCardFee;
				var newTotal = currentTotal + cardFee;
				var cardFeeFormatted = !isNaN(cardFee) ? "$" + cardFee.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : undefined;
				var newTotalFormatted = !isNaN(newTotal) ? "$" + newTotal.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : undefined;

				context.cardFeeFormatted = cardFeeFormatted;
				context.newTotalFormatted = newTotalFormatted;

				context.cardFeeApplied = ccFeeApplied;
				context.creditCardFeeText = this.creditCardFeeText;

				return context;
			});

			// Choosing payment method sets if fee is applied or not
			OrderWizardModulePaymentMethodSelector.prototype.render = _.wrap(OrderWizardModulePaymentMethodSelector.prototype.render, function(fn) {
				var context = fn.apply(this, _.toArray(arguments).slice(1));

				paymentMethod = this.selectedModule.name;

				if (paymentMethod == "Credit / Debit Card" && !ccFeeApplied) {
					ccFeeApplied = true;
					getStepToRefresh();
					// alert("Payment with a Credit or Debit Card will result in a 2% fee.");
				} else if (paymentMethod == "Invoice" && ccFeeApplied) {
					ccFeeApplied = false;
					getStepToRefresh();
					checkIfTotalOverAvailableBalance();
				}
				
			});

			// For each step, make sure proper info is displayed
			checkout.on("afterShowContent", function() {
				checkout.getCurrentStep().then(function(step) {
					console.log(step);
					if (step.url == "confirmation") {
						if (ccFeeApplied) {
							$(".order-wizard-cart-summary-container").html(summaryHTML);
						}
					} else if (step.name == "Review Your Order") {
						cart.getPaymentMethods().then(function(paymentmethods) {
							console.log(paymentmethods);
							var paymentmethodtype = paymentmethods[0].type;
							console.log(paymentmethodtype);
		
							if (paymentmethodtype == "creditcard") {
								ccFeeApplied = true;
								getStepToRefresh();
							} else {
								ccFeeApplied = false;
								getStepToRefresh();
							}
						});
					} else if (step.name == "Choose Payment Method") {
						checkIfTotalOverAvailableBalance();
					} else {
						getStepToRefresh();
					}
				});
			});

			function getStepToRefresh() {
				checkout.addModuleToStep({
					step_url: 'billing'
				,	module: {
						id: 'new_module'
					,	index: 0
					,	classname: 'OrderWizard.Module.CartSummary'
					,	options: { container: '#wizard-step-content-right'}
					}
				}).then(function() {
					console.log("Reloaded");						
					checkout.removeModuleFromStep({
						step_url: 'billing',
						module_id: 'new_module'
					}).then(function() {
						summaryHTML = $(".order-wizard-cart-summary-container").html();
					});
				});
			}

			function checkIfTotalOverAvailableBalance() {
				console.log("Checking if over terms");
				cart.getSummary().then(function(summary) {
					var total = summary.total;
					console.log(total);
					var availableBalance = $('.order-wizard-paymentmethod-invoice-module-balance-value').html().trim().replace('$', '').replace(',', '');
					console.log(availableBalance);

					if (total > availableBalance) {
	
						alert("The total for this order exceeds your available balance. The order will need to be reviewed by our accounting team for approval. Otherwise, please click “Pay Now” to process your order immediately.")
					}

				});
			}

			_.extend(OrderWizardModulePaymentMethodSelector.prototype, {
				initialize: _.wrap(OrderWizardModulePaymentMethodSelector.prototype.initialize, function (fn) {
					fn.apply(this, _.toArray(arguments).slice(1));
					this.setModuleByType('invoice', true);
					var style = $('<style> #custbody_payment_token, #custbody_preset_url_key { display:none; }</style>');
					$('html > head').append(style);
				})
			});
			_.extend(OrderWizardModulePaymentMethodCreditcard.prototype, {
				isActive: function () {
					return false;
				}
			});
		}
	};
});
